// Uiuxfuture.js
import React, { useEffect, useRef, useState } from "react";
import "../Style/Uiuxfuture.css";

import iconUser from "../assets/U.png";
import iconWireframe from "../assets/W.png";
import iconModernUI from "../assets/M.png";
import iconMobile from "../assets/R.png";
import iconUsability from "../assets/T.png";

const services = [
  {
    id: 1,
    icon: iconUser,
    alt: "User-Centered Design",
    title: "User-Centered Design",
    text: "Every design decision begins with understanding your users. Through in-depth research, behavioral analysis, and customer insights, we create intuitive digital experiences that solve real problems while improving engagement, satisfaction, and retention.",
    row: "top",
  },
  {
    id: 2,
    icon: iconWireframe,
    alt: "Wireframing & Interactive Prototyping",
    title: "Wireframing & Prototyping",
    text: "We transform ideas into structured wireframes and interactive prototypes that validate concepts before development. This approach reduces project risks, improves collaboration, and ensures every feature aligns with user expectations and business goals.",
    row: "top",
  },
  {
    id: 3,
    icon: iconModernUI,
    alt: "Modern UI Design",
    title: "Modern UI Design",
    text: "Our designers craft visually stunning interfaces with consistent branding, modern layouts, intuitive navigation, and accessibility best practices. Every screen is designed to deliver exceptional user experiences across web and mobile platforms.",
    row: "top",
  },
];

const Uiuxfuture = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`uxfuture-main-section ${isVisible ? "uxfuture-visible" : ""}`}
      ref={sectionRef}
    >
      <div className="uxfuture-glow uxfuture-glow-1" aria-hidden="true" />
      <div className="uxfuture-glow uxfuture-glow-2" aria-hidden="true" />

      <div className="uxfuture-main-container">
        <span className="uxfuture-eyebrow uxfuture-anim uxfuture-anim-0">
          Our Approach
        </span>

        {/* Heading */}
        <h1 className="uxfuture-main-title uxfuture-anim uxfuture-anim-1">
          The Future of UI/UX Design Starts with Better User Experiences
        </h1>

        {/* Delivered by */}
        <p className="uxfuture-subtitle-label uxfuture-anim uxfuture-anim-2">
          Delivered by MPeoples
        </p>

        {/* Description */}
        <p className="uxfuture-main-description uxfuture-anim uxfuture-anim-3">
          Exceptional digital products are built around people, not just
          technology. At MPeoples, we combine user research, innovative design
          thinking, modern UI trends, and proven UX strategies to create
          engaging digital experiences that increase customer satisfaction,
          improve conversions, and accelerate business growth. Every interface
          we design is optimized for usability, accessibility, scalability, and
          long-term success.
        </p>

        {/* Cards Grid */}
        <div className="uxfuture-card-grid">
          {/* Top row — 3 cards */}
          {services
            .filter((s) => s.row === "top")
            .map((service, i) => (
              <div
                key={service.id}
                className={`uxfuture-service-card uxfuture-anim uxfuture-anim-${4 + i}`}
              >
                <div className="uxfuture-card-header">
                  <div className="uxfuture-card-icon-wrap">
                    <img
                      src={service.icon}
                      alt={service.alt}
                      className="uxfuture-card-icon"
                    />
                  </div>
                  <h3 className="uxfuture-card-title">{service.title}</h3>
                </div>
                <p className="uxfuture-card-text">{service.text}</p>
              </div>
            ))}

          {/* Bottom row — 2 cards */}
          <div className="uxfuture-service-card uxfuture-card-bottom-left uxfuture-anim uxfuture-anim-7">
            <div className="uxfuture-card-header">
              <div className="uxfuture-card-icon-wrap">
                <img
                  src={iconMobile}
                  alt="Mobile-First & Responsive Design"
                  className="uxfuture-card-icon"
                />
              </div>
              <h3 className="uxfuture-card-title">
                Mobile-First &amp; Responsive Design
              </h3>
            </div>
            <p className="uxfuture-card-text">
              We build responsive user interfaces that perform flawlessly across
              smartphones, tablets, laptops, and desktops. Our mobile-first
              approach ensures fast loading, seamless navigation, and a
              consistent experience on every device.
            </p>
          </div>

          <div className="uxfuture-service-card uxfuture-card-bottom-right uxfuture-anim uxfuture-anim-8">
            <div className="uxfuture-card-header">
              <div className="uxfuture-card-icon-wrap">
                <img
                  src={iconUsability}
                  alt="Usability Testing & Optimization"
                  className="uxfuture-card-icon"
                />
              </div>
              <h3 className="uxfuture-card-title">
                Usability Testing &amp; Optimization
              </h3>
            </div>
            <p className="uxfuture-card-text">
              Before launch, every design undergoes comprehensive usability
              testing and performance validation. By analyzing real user
              feedback, we continuously refine the experience to improve
              usability, increase engagement, and maximize conversions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Uiuxfuture;